import moment from "moment";
import numeral from "numeral";
function getFormatDate(date) {
  return moment(date).format("DD/MM/YYYY");
}
function deduplicate(arr) {
  let isExist = (arr, element) =>
    arr.find((x) => x.itemCode === element.itemCode);
  let result = [];

  arr.forEach((element) => {
    if (!isExist(result, element)) result.push(element);
  });
  return result;
}
function countItem(item, listOrders) {
  let listItem = [];
  listOrders.forEach((item) => {
    listItem = listItem.concat(item.item);
  });
  let count = 0;
  listItem.forEach((element) => {
    if (item.itemType !== "memberCard" && item.itemCode === element.itemCode) {
      count += element.quantity;
    } else if (item.itemCode === element.itemCode) {
      // Member Card không có quantity
      count++;
    }
  });
  return count;
}
function countValue(item, listOrders) {
  let listItem = [];
  listOrders.forEach((item) => {
    listItem = listItem.concat(item.item);
  });
  let count = 0;
  listItem.forEach((element) => {
    if (item.itemType !== "memberCard" && item.itemCode === element.itemCode) {
      count += element.quantity * element.itemPrice;
    } else if (item.itemCode === element.itemCode) {
      // Member Card không có quantity
      count += element.itemPrice;
    }
  });
  return count;
}
function getValueDiscount(order) {
  if (order.discount.type === "percent")
    return order.discount.value * order.tempPrice;
  return order.discount.value;
}
function getValueVoucher(order) {
  if (order.voucher.type === "percent")
    return order.voucher.discount * order.tempPrice;
  return order.voucher.discount;
}

export default function (data) {
  let today = moment(new Date()).format("DD/MM/YYYY  h:mm A");

  // Item Order Break Down
  let listItem = [];
  let subTotal = 0;
  data.listOrders.forEach((item) => {
    subTotal += item.tempPrice;
  });
  let total =
    data.service.usingTax === 1
      ? subTotal + subTotal * data.setting.tax
      : subTotal;
  data.listOrders.forEach((item) => {
    listItem = listItem.concat(item.item);
  });
  listItem = deduplicate(listItem);
  listItem = listItem.filter((item) => item.itemCode);
  let renderItemOrder = [];
  renderItemOrder.push([
    {
      text: "",
      bold: true,
    },
    {
      text: data.t("report_count"),
      style: "title",
    },
    {
      text: data.t("report_amount"),
      alignment: "right",
    },
  ]);
  listItem.forEach((item) => {
    renderItemOrder.push([
      {
        text: item.itemName,
        margin: [16, 16, 0, 0],
      },
      {
        text: countItem(item, data.listOrders),
        alignment: "center",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${numeral(countValue(item, data.listOrders)).format("0,0")} ${
          data.setting.currencyCode
        }`,
        alignment: "right",
        margin: [0, 16, 0, 0],
      },
    ]);
  });

  // Appointment Statistics
  const listBookingApp = data.listBookings.filter(
    (item) => item.createdBySpa === false
  );
  const listBookingNewClient = data.listBookings.filter(
    (item) => item.isFirstBooking === true
  );
  const listBookingMissed = data.listBookings.filter(
    (item) => item.status === "missed"
  );
  const listWalkIn = data.listOrders.filter((item) => {
    if (item.booking) {
      return Object.keys(item.booking).length > 0;
    }
    return false;
  });
  // Invoice Details
  let valueDiscount = 0;
  const listAborted = data.listOrders.filter((item) => item.status === "abort");
  const listDiscount = data.listOrders.filter(
    (item) => item.discount.value > 0
  );
  listDiscount.forEach((element) => {
    valueDiscount += getValueDiscount(element);
  });

  //Profit Breakdown
  let valueOrders = 0;
  data.listOrders.forEach((element) => {
    valueOrders += element.totalPrice;
  });

  let salary = 0;
  if (data.serviceCost[0] && data.serviceCost[0].serviceCost) {
    let employeeSalary = data.serviceCost[0].serviceCost.find(
      (item) => item.name === "employee_salary"
    );
    salary = employeeSalary ? employeeSalary.value : 0;
  }

  // Payment Type Breakdown
  let valueVoucher = 0;
  let tempPrice = 0;
  const listVoucher = data.listOrders.filter((item) => {
    if (item.voucher) return Object.keys(item.voucher).length > 0;
    return false;
  });
  listVoucher.forEach((element) => {
    valueVoucher += getValueVoucher(element);
  });

  data.listOrders.forEach((element) => {
    tempPrice += element.tempPrice;
  });
  tempPrice -= valueVoucher;

  return {
    info: {
      title: "ReportSpa",
      author: "Masspa",
      subject: "Report",
      keywords: "keywords for document",
    },
    content: [
      {
        columns: [
          {
            // % width
            width: "50%",
            alignment: "left",
            text: today,
          },
          {
            // % width
            width: "50%",
            alignment: "right",
            text: "Masspa 0.0.1",
          },
        ],
        // optional space between columns
        columnGap: 10,
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: "",
                border: [false, false, false, true],
                margin: [0, 16, 0, 0],
              },
            ],
          ],
        },
      },
      {
        text: data.t("report_business_sumary_report"),
        style: "header",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${data.t("report_report_for")}: ${getFormatDate(
          data.from
        )} - ${getFormatDate(data.to)}`,
        alignment: "center",
        fontSize: 14,
        margin: [0, 0, 0, 16],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                fillColor: "#FFECEB",
                text: data.t("report_sale_break_down"),
                bold: true,
                margin: [16, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          defaultBorder: false,
        },
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: "",
                bold: true,
                margin: [0, 16, 0, 0],
              },
            ],
          ],
        },
        layout: {
          defaultBorder: false,
        },
      },
      {
        columns: [
          [
            {
              table: {
                widths: ["40%", "20%", "40%"],
                body: renderItemOrder,
              },
              layout: {
                defaultBorder: false,
              },
            },
            {
              table: {
                widths: ["50%", "50%"],
                body: data.service.usingTax
                  ? [
                      [
                        {
                          text: `${data.t("report_subtotal")}:`,
                          margin: [16, 12, 0, 0],
                        },
                        {
                          text: `${numeral(subTotal).format("0,0")} ${
                            data.setting.currencyCode
                          }`,
                          alignment: "right",
                          margin: [0, 12, 0, 0],
                        },
                      ],
                      [
                        {
                          text: `${data.t("report_tax")}:`,
                          margin: [16, 0, 0, 12],
                        },
                        {
                          text: `${numeral(subTotal * data.setting.tax).format(
                            "0,0"
                          )} ${data.setting.currencyCode}`,
                          alignment: "right",
                          margin: [0, 0, 0, 12],
                        },
                      ],
                    ]
                  : [
                      [
                        {
                          text: `${data.t("report_subtotal")}:`,
                          margin: [16, 12, 0, 0],
                        },
                        {
                          text: `${numeral(subTotal).format("0,0")} ${
                            data.setting.currencyCode
                          }`,
                          alignment: "right",
                          margin: [0, 12, 0, 0],
                        },
                      ],
                    ],
              },
              layout: {
                hLineWidth: function (i, node) {
                  return i === 0 || i === node.table.body.length ? 1 : 0;
                },
                vLineWidth: function (i, node) {
                  return 0;
                },
                hLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length
                    ? "#E8E9EC"
                    : "gray";
                },
                // vLineColor: function (i, node) {
                //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
                // },
              },
            },
            {
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      text: `${data.t("report_total")}:`,
                      margin: [16, 12, 0, 32],
                    },
                    {
                      text: `${numeral(total).format("0,0")} ${
                        data.setting.currencyCode
                      }`,
                      alignment: "right",
                      margin: [0, 12, 0, 32],
                    },
                  ],
                ],
              },
              layout: "noBorders",
            },
            {
              table: {
                widths: ["100%"],
                body: [
                  [
                    {
                      text: data.t("report_appointment_statistics"),
                      bold: true,
                      fillColor: "#E8E9EC",
                      margin: [16, 0, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
              },
            },
            {
              table: {
                widths: ["70%", "30%"],
                body: [
                  [
                    {
                      text: `${data.t("report_total_booking")}:`,
                      margin: [16, 16, 0, 0],
                    },
                    {
                      text: data.totalBooking,
                      alignment: "right",
                      margin: [0, 16, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${data.t("report_total_booking_app")}:`,
                      margin: [16, 0, 0, 0],
                    },
                    {
                      text: `(${Math.round(
                        data.totalBooking > 0
                          ? (listBookingApp.length * 100) / data.totalBooking
                          : 0,
                        0.05
                      )}%) ${listBookingApp.length}`,
                      alignment: "right",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${data.t("report_unique_client")}:`,
                      margin: [16, 0, 0, 0],
                    },
                    {
                      text: `(${Math.round(
                        data.totalBooking > 0
                          ? ((data.totalBooking - listBookingNewClient.length) *
                              100) /
                              data.totalBooking
                          : 0,
                        0.05
                      )}%) ${data.totalBooking - listBookingNewClient.length}`,
                      alignment: "right",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${data.t("report_unique_client")}:`,
                      margin: [16, 0, 0, 0],
                    },
                    {
                      text: `(${Math.round(
                        data.totalBooking > 0
                          ? (listBookingNewClient.length * 100) /
                              data.totalBooking
                          : 0,
                        0.05
                      )}%) ${listBookingNewClient.length}`,
                      alignment: "right",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${data.t("report_walk_in_client")}:`,
                      margin: [16, 0, 0, 0],
                    },
                    {
                      text: listWalkIn.length,
                      alignment: "right",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${data.t("report_client_not_checked_in")}:`,
                      margin: [16, 0, 0, 0],
                    },
                    {
                      text: `(${Math.round(
                        data.totalBooking > 0
                          ? (listBookingMissed.length * 100) / data.totalBooking
                          : 0,
                        0.05
                      )}%) ${listBookingMissed.length}`,
                      alignment: "right",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${data.t("report_total_booking_success")}:`,
                      margin: [16, 0, 0, 0],
                    },
                    {
                      text: `(${Math.round(
                        data.totalBooking > 0
                          ? ((data.totalBooking - listBookingMissed.length) *
                              100) /
                              data.totalBooking
                          : 0,
                        0.05
                      )}%) ${data.totalBooking - listBookingMissed.length}`,
                      alignment: "right",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                ],
              },
              layout: "noBorders",
            },
          ],
          [
            {
              table: {
                widths: ["100%"],
                body: [
                  [
                    {
                      text: data.t("report_invoice_detail"),
                      bold: true,
                      fillColor: "#E8E9EC",
                      margin: [16, 0, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
              },
            },
            {
              table: {
                widths: ["70%", "30%"],
                body: [
                  [
                    {
                      text: data.t("report_invoice"),
                      bold: true,
                      margin: [16, 16, 0, 0],
                    },
                    {
                      text: data.totalOrder,
                      alignment: "right",
                      margin: [0, 16, 0, 0],
                    },
                  ],
                  [
                    {
                      text: data.t("report_aborted"),
                      margin: [16, 0, 0, 0],
                    },
                    {
                      text: listAborted.length,
                      alignment: "right",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                ],
              },
              layout: "noBorders",
            },
            {
              table: {
                widths: ["30%", "30%", "40%"],
                body: [
                  [
                    {
                      text: data.t("report_discount"),
                      bold: true,
                      margin: [16, 16, 0, 32],
                    },
                    {
                      text: listDiscount.length,
                      bold: true,
                      alignment: "center",
                      margin: [0, 16, 0, 32],
                    },
                    {
                      text: `${numeral(valueDiscount).format("0,0")} ${
                        data.setting.currencyCode
                      }`,
                      bold: true,
                      alignment: "right",
                      margin: [0, 16, 0, 32],
                    },
                  ],
                ],
              },
              layout: "noBorders",
            },
            {
              table: {
                widths: ["100%"],
                body: [
                  [
                    {
                      text: data.t("report_profit_reakdown"),
                      bold: true,
                      fillColor: "#E8E9EC",
                      margin: [16, 0, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
              },
            },
            {
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      text: `${data.t("report_avg_sales")}:`,
                      margin: [16, 16, 0, 0],
                    },
                    {
                      text: `${numeral(
                        Math.round(valueOrders / data.totalOrder)
                      ).format("0,0")} ${data.setting.currencyCode}`,
                      alignment: "right",
                      margin: [0, 16, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${data.t("report_gross_sales")}:`,
                      margin: [16, 0, 0, 0],
                    },
                    {
                      text: `${numeral(valueOrders).format("0,0")} ${
                        data.setting.currencyCode
                      }`,
                      alignment: "right",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${data.t("report_total_cost")}:`,
                      margin: [16, 0, 0, 12],
                    },
                    {
                      text: `${numeral(salary).format("0,0")} ${
                        data.setting.currencyCode
                      }`,
                      alignment: "right",
                      margin: [0, 0, 0, 12],
                    },
                  ],
                ],
              },
              layout: "noBorders",
            },
            {
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      text: `${data.t("report_net_profit")}:`,
                      bold: true,
                      margin: [16, 16, 0, 32],
                    },
                    {
                      // text: '$26,784.2',
                      text: `${numeral(valueOrders - salary).format("0,0")} ${
                        data.setting.currencyCode
                      }`,
                      alignment: "right",
                      bold: true,
                      margin: [0, 16, 0, 32],
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: function (i, node) {
                  return i === 0 ? 1 : 0;
                },
                vLineWidth: function (i, node) {
                  return 0;
                },
                hLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length
                    ? "#E8E9EC"
                    : "gray";
                },
              },
            },
            {
              table: {
                widths: ["100%"],
                body: [
                  [
                    {
                      text: data.t("report_payment_type_breakdown"),
                      bold: true,
                      fillColor: "#E8E9EC",
                      margin: [16, 0, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
              },
            },
            {
              table: {
                widths: ["40%", "20%", "40%"],
                body: [
                  [
                    {
                      text: "",
                      bold: true,
                      margin: [0, 26, 0, 0],
                    },
                    {
                      text: data.t("report_count"),
                      style: "title",
                      margin: [0, 26, 0, 0],
                    },
                    {
                      text: data.t("report_amount"),
                      alignment: "right",
                      margin: [0, 26, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${data.t("report_cash")}:`,
                      margin: [16, 16, 0, 0],
                    },
                    {
                      text: data.totalOrder,
                      alignment: "center",
                      margin: [0, 16, 0, 0],
                    },
                    {
                      text: `${numeral(tempPrice - valueVoucher).format(
                        "0,0"
                      )} ${data.setting.currencyCode}`,
                      alignment: "right",
                      margin: [0, 16, 0, 0],
                    },
                  ],
                  [
                    {
                      text: "Direct:",
                      margin: [16, 0, 0, 0],
                    },
                    {
                      text: "0",
                      alignment: "center",
                    },
                    {
                      text: "0",
                      alignment: "right",
                    },
                  ],
                  [
                    {
                      text: "Visa/Master Card:",
                      margin: [16, 0, 0, 0],
                    },
                    {
                      text: "0",
                      alignment: "center",
                    },
                    {
                      text: "0",
                      alignment: "right",
                    },
                  ],
                  [
                    {
                      text: "Coupon:",
                      margin: [16, 0, 0, 12],
                    },
                    {
                      text: listVoucher.length,
                      alignment: "center",
                      margin: [0, 0, 0, 12],
                    },
                    {
                      text: `${numeral(valueVoucher).format("0,0")} ${
                        data.setting.currencyCode
                      }`,
                      alignment: "right",
                      margin: [0, 0, 0, 12],
                    },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
              },
            },
            {
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      text: `${data.t("report_total")}:`,
                      margin: [16, 12, 0, 0],
                    },
                    {
                      text: `${numeral(tempPrice).format("0,0")} ${
                        data.setting.currencyCode
                      }`,
                      alignment: "right",
                      margin: [0, 12, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: function (i, node) {
                  return i === 0 ? 1 : 0;
                },
                vLineWidth: function (i, node) {
                  return 0;
                },
                hLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length
                    ? "#E8E9EC"
                    : "gray";
                },
              },
            },
          ],
        ],
        // optional space between columns
        columnGap: 32,
      },
    ],
    styles: {
      header: {
        fontSize: 24,
        bold: true,
        color: "#ff513f",
        alignment: "center",
      },
      title: {
        fontSize: 12,
        bold: true,
        color: "#292f48",
        alignment: "center",
      },
      anotherStyle: {
        italics: true,
        alignment: "right",
      },
    },
    defaultStyle: {
      fontSize: 12,
      bold: false,
      color: "#292f48",
    },
    // a string or { width: number, height: number }
    pageSize: "A4",

    // by default we use portrait, you can change it to landscape if you wish
    pageOrientation: "portrait",

    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
    pageMargins: [24, 24, 24, 24],
  };
}
